module.exports = __webpack_public_path__ + "static/media/vision-ico.f67661ed.svg";